import React from "react";
import { useTranslation } from "react-i18next";
import currencyFormatter, { Currency } from "@/common/CurrencyFormatter";

interface BasketFreeShippingNoteProperties {
    readonly itemsCount: number;
    readonly itemsAmount: number;
    readonly freeShippingMinimalOrderPrice: number;
    readonly currency: Currency;
}

export default function BasketFreeShippingNote({
    itemsCount,
    freeShippingMinimalOrderPrice,
    itemsAmount,
    currency,
}: BasketFreeShippingNoteProperties): React.JSX.Element {
    const { t } = useTranslation("basket");

    if (itemsAmount >= freeShippingMinimalOrderPrice) {
        return (
            <div className="alert alert-success cart-step1-alert">
                <div className="watchdog-new-1-top">
                    <a aria-label="close" className="close" href="#">
                        <i className="fa-solid fa-times"></i>
                    </a>
                    <div className="watchdog-new-1-data">
                        <i className="fa-solid fa-check-circle"></i>
                        <span>
                            <strong>{t("congratulationsFreeShipping")} &#129395;</strong>
                            {itemsCount > 15 && t("freeShippingLimited")}
                        </span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="alert alert-success cart-step1-alert">
            <div className="watchdog-new-1-top">
                <div className="watchdog-new-1-data">
                    <i className="fa-solid fa-gift"></i>
                    <span>
                        {t("addItemsToCart")}
                        <strong>
                            {t("moreToFreeShipping", {
                                amount: currencyFormatter.formatCurrencyWithSymbol(freeShippingMinimalOrderPrice - itemsAmount, currency),
                            })}
                        </strong>
                        {t("andGetFreeShipping")}
                    </span>
                </div>
            </div>
        </div>
    );
}
